// extracted by mini-css-extract-plugin
module.exports = {"will__change":"simple-form_will__change__hi7kk","formContent":"simple-form_formContent__NQhUP","simpleForm":"simple-form_simpleForm__IQ5JQ"};